import request from "@/utils/request.js";

class Api {
  // 添加角色
  addRoles(data) {
    return request({
      method: "post",
      url: "/role/add",
      data,
    });
  }
  // 角色列表
  rolesList() {
    return request({
      method: "get",
      url: "/role/list",
    });
  }
  // 编辑角色
  editRole(data) {
    return request({
      method: "post",
      url: "/role/edit",
      data,
    });
  }
  // 删除角色
  deleteRole(data) {
    return request({
      method: "post",
      url: "/role/del",
      data,
    });
  }
  // 角色权限列表
  roleAuthList(params) {
    return request({
      method: "get",
      url: "/role/auth/list",
      params,
    });
  }
  // 更新角色权限列表
  updateRoleAuth(data) {
    return request({
      method: "post",
      url: "/role/auth/update",
      data,
    });
  }
}

export default new Api();
